import styled from 'styled-components'

export const StyledClinLoaderSVG = styled.svg({
  maxWidth: 244,
  maxHeight: 244,
  flex: '1 0 auto'
})
